
export function Twitter()
{
	return (
		<svg id="twitter" class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path class="foregroundColour" d="M32 0c17.7 0 32 14.3 32 32S49.7 64 32 64 0 49.7 0 32 14.3 0 32 0z"/><path class="backgroundColour" d="M51 20.6c-1.4.6-2.9 1-4.5 1.2 1.6-.9 2.8-2.4 3.4-4.2-1.5.9-3.2 1.5-5 1.8-1.4-1.5-3.4-2.4-5.7-2.4-4.3 0-7.8 3.4-7.8 7.6 0 .6.1 1.2.2 1.7-6.4-.3-12.1-3.3-16-7.9-.7 1.1-1.1 2.4-1.1 3.8 0 2.6 1.4 4.9 3.5 6.3-1.3 0-2.5-.4-3.5-.9v.1c0 3.7 2.7 6.7 6.3 7.4-.7.2-1.3.3-2.1.3-.5 0-1 0-1.5-.1 1 3 3.9 5.2 7.3 5.3-2.7 2-6 3.2-9.7 3.2-.6 0-1.2 0-1.9-.1 3.5 2.1 7.5 3.4 12 3.4 14.3 0 22.2-11.5 22.2-21.5v-1c1.5-1.2 2.9-2.5 3.9-4z"/></svg>
	);
}
